exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".signature-wrapper[data-v-03ae01a4]{border:1px solid #ced4da;border-radius:.25rem;overflow:hidden;max-height:320px}.signature-wrapper .signature-canvas[data-v-03ae01a4]{border-bottom:1px dashed #000;margin-bottom:1rem;width:100%}.signature-wrapper .btn[data-v-03ae01a4]{display:block;float:none;width:auto;position:absolute;bottom:0;right:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-03ae01a4","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/SignatureComponent.vue
// module id = KVbC
// module chunks = 0